<template lang="pug">
  main
    NavBar
    ModalYN(v-show="verModal" :config="configModal" @padre:close="deleteVisita")
    Loader(v-show="isLoading")
    section.section
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h3.title Asistencia a Corporativo
        .columns.is-mobile
          .column.is-1
            label.label Fecha:
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fecha'
                  :config="config"
                  class="input"
                )
          .column.is-1
            a.button.is-black.is-rounded.is-small(@click="iniciarComponente")
              span.icon
                i.fas.fa-sync
          .column.is-8
            //- input#cNieto.is-checkradio.is-black(type='radio', value='1' v-model='filter')
            //- label.is-size-6(for='cNieto') Adenergy Nieto
            //- input#cDucter.is-checkradio.is-black(type='radio', value='0' v-model='filter')
            //- label.is-size-6(for='cDucter') Ducter
            //- input#cFinanciera.is-checkradio.is-black(type='radio', value='2' v-model='filter')
            //- label.is-size-6(for='cFinanciera') Financiera Nieto Fin
            input#cExternos.is-checkradio.is-black(type='radio', value='3' v-model='filter')
            label.is-size-6(for='cExternos') Externos
        .columns
          .column.is-12
            TbVisitas(:visitas='visitasSel' @eliminarVisita="eliminarVisita")
      .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBar'
  import Loader from '@/components/shared/Loader.vue'
  import TbVisitas from './components/TbVisitas'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import ModalYN from '@/components/shared/ModalYN.vue'
  import moment from 'moment'

  import VisitasServices from '@/services/visitas/visitas'

  export default {
    name: 'Visitas',
    components: { NavBar, Loader, flatPickr, TbVisitas, ModalYN },
    data() {
      return {
        isLoading: false,
        filter: '3',
        fecha: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only
        },
        visitas: [],
        visitasSel: [],
        verModal: false,
        configModal: {},
        visitaSel: {}
      }
    },
    watch: {
      fecha() {
        this.obtenerVisitas()
      },
      filter () {
        this.visitasSel = this.visitas.filter( vis => vis.compania == parseInt(this.filter))
      },
    },
    methods: {
      iniciarComponente() {
        this.obtenerVisitas()
      },

      obtenerVisitas() {
        VisitasServices.getVisitas(this.fecha)
          .then( data => {
            this.visitas = data.map(this.convertirAsistencias)
            this.visitasSel = this.visitas.filter( vis => vis.compania == this.filter)
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },


      convertirAsistencias(vis) {
        const hora = moment(vis.fecha).format('HH:mm')
        return {
          ...vis,
          id: parseInt(vis.id),
          contactoC19: parseInt(vis.contactoC19),
          contactoS: parseInt(vis.contactoS),
          dificultadR: parseInt(vis.dificultadR),
          dolorC: parseInt(vis.dolorC),
          dolorG: parseInt(vis.dolorG),
          dolorM: parseInt(vis.dolorM),
          escurrimiento: parseInt(vis.escurrimiento),
          olfatoGusto: parseInt(vis.olfatoGusto),
          fiebre: parseInt(vis.fiebre),
          ojosI: parseInt(vis.ojosI),
          temperatura: parseInt(vis.temperatura),
          tos: parseInt(vis.tos),
          hora: hora
        }
      },

      eliminarVisita (vis) {
        this.visitaSel = vis
        this.configModal = {
          title: 'Eliminar Visita',
          content: `¿Desea eliminar la visita de ${vis.nombre}?`,
          textCancel: 'Cancelar',
          textOk: 'Eliminar'
        }
        this.verModal = true
      },

      deleteVisita (resp) {
        if (resp) {
          VisitasServices.deleteVisita(this.visitaSel.id)
            .then( data => {
              if (data.success) {
                this.displayToast('toasted-primary', data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                this.isLoading = false
                this.iniciarComponente()
              } else {
                this.isLoading = false
                this.displayToast('bubble',`Error: ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
        }
        this.verModal = false
        this.visitaSel = {}
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: tema,
          position: "bottom-right",
          duration : 3000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/visitas_Componentes/Visitas.vue